import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyHeading, MyGlobal, MyAlert } from '../../GlobalContext';

export class RF_AdditionalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            loading: true,
            alertMessage: this.props.validationMessage,
            inventoriesToPut: this.props.inventoriesToPut,
            destinationLocationBarcode: this.props.toLocation,
            destinationLocationInventories: [],
            destinationLocationTotes: [],
            
        };

    }

    componentDidMount() {
        this.bindInventories();
    }
    bindInventories() {

        this.setState({ loading: true });

        const { destinationLocationBarcode } = this.state;
        const warehouseID = MyGlobal.warehouse;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                DestinationLocationBarcode: destinationLocationBarcode,
                WarehouseId: warehouseID
            })
        };

        fetch(`api/Transfer/GetAdditionalInfo`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result && result.success) {
                    this.setState({
                        destinationLocationInventories: result.data?.destination?.inventories || [],
                        destinationLocationTotes: result.data?.destination?.totes || [],
                        loading: false
                    });
                } else {
                    throw new Error(result.errorMessage || "Failed to fetch data");
                }
            })
            .catch(error => {
                this.setState({ alertMessage: "Error fetching inventories: " + error.message, loading: false });
            });
    }

    renderTable(data, isTote = false) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Grade1</th>
                        <th>Grade2</th>
                        <th>Grade3</th>
                        <th>PackingDate</th>
                        <th>ExpiryDate</th>
                        <th>Units</th>
                        {!isTote && <th>Committed</th>}
                        <th>Client</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) =>
                        <tr key={index}>
                            <td>{row.productCode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.grade1}</td>
                            <td>{row.grade2}</td>
                            <td>{row.grade3}</td>
                            <td>{row.packingDate ? new Date(row.packingDate).toLocaleDateString() : ''}</td>
                            <td>{row.expiryDate ? new Date(row.expiryDate).toLocaleDateString() : ''}</td>
                            <td>{row.units}</td>
                            {!isTote && <td>{row.committedUnits}</td>}
                            <td>{row.clientName}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {

        let sourceLocationInventoryContents = this.renderTable(this.state.inventoriesToPut);
        let destinationLocationInventoryContents = this.renderTable(this.state.destinationLocationInventories);
        let destinationLocationToteContents = this.renderTable(this.state.destinationLocationTotes, true);

        let loadingProgress = this.state.loading ? <Container><Row><Col><p><em>Loading...</em></p> </Col></Row></Container> : <p></p>;

        const alertMessage = this.state.alertMessage;
        const formatAlertMessage = message => {
            if (typeof message !== 'string') {
                return null;
            }
            return message.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line.split('**').map((part, i) =>
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                    )}
                    <br />
                </React.Fragment>
            ));
        };

        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered size="xl">

                    <Modal.Header>
                        <Modal.Title>Transfers - Additional Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {loadingProgress}
                        <Container>
                            <Row>
                                <Col>
                                    {alertMessage !== "" && (
                                        <MyAlert variant="danger">
                                            {formatAlertMessage(alertMessage)}
                                        </MyAlert>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h6>Picked Product:</h6>
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                    <div className="tableHolder hm-50vh mb-3">
                                        {sourceLocationInventoryContents}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h6> Destination Location : {this.state.destinationLocationBarcode}</h6>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h6> Inventories:</h6>
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                    <div className="tableHolder hm-50vh mb-3">
                                        {destinationLocationInventoryContents}
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{ display: this.state.destinationLocationTotes && this.state.destinationLocationTotes.length > 0 ? 'block' : 'none' }} >
                                <Col>
                                    <h6> Totes:</h6>
                                </Col>
                                <Col>
                                    <div className="tableHolder hm-50vh mb-3">
                                        {destinationLocationToteContents}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-success col-12 mb-2" onClick={this.props.onClickClose}>
                            Close
                        </Button>
                    </Modal.Footer>

                </Modal>
            </>
        );
    }
}

export default RF_AdditionalInfo;